import { type Language as LanguageWithFlagType } from '../components/LanguageDropdown'
import { FLAG_ASSETS } from '../constants/asset'

// Local storage key for language
export const LOCAL_STORAGE_KEY = 'lang' as const

export enum Language {
  TH = 'th',
  EN = 'en',
  MY = 'my',
  KM = 'km',
}

export const DEFAULT_LANGUAGE = Language.TH

/**
 * Language constants
 * Code: ISO 639-1 (Language)
 * Label: ISO 3166-1 alpha2 (Country)
 * Flag: Flag asset
 */
export const LANGUAGES: LanguageWithFlagType[] = [
  { code: Language.TH, label: 'TH', flag: FLAG_ASSETS.th },
  { code: Language.EN, label: 'EN', flag: FLAG_ASSETS.en },
  { code: Language.MY, label: 'MM', flag: FLAG_ASSETS.mm },
  { code: Language.KM, label: 'KH', flag: FLAG_ASSETS.km },
]
